import { supabase } from './supabase';

function getSessionId(): string {
  let id = sessionStorage.getItem('professya_funnel_session');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('professya_funnel_session', id);
  }
  return id;
}

export type FunnelEventType =
  | 'viewed_chart_visual'
  | 'read_free_interpretation'
  | 'hit_paywall'
  | 'clicked_upgrade_cta'
  | 'viewed_pricing'
  | 'started_checkout'
  | 'completed_payment'
  | 'became_paid_user';

export async function trackFunnelEvent(
  eventType: FunnelEventType,
  metadata: Record<string, unknown> = {}
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('user_funnel_events').insert({
      user_id:    user?.id ?? null,
      session_id: getSessionId(),
      event_type: eventType,
      metadata,
    });
  } catch {
    // Never block UX for analytics
  }
}
